"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatePrizeTable = void 0;
var generatePrizeTable_1 = __importDefault(require("./generatePrizeTable"));
exports.generatePrizeTable = generatePrizeTable_1.default;
